module.exports = __webpack_public_path__ + "img/12-IP-navigate-the-interview-with-ease.d9429f92.svg";